import { useAuth } from "../context/AuthContext";
import { memo } from "react";
import { Navigate } from "react-router-dom";

export const AdminOrEmployeeRoute = memo(function AdminOrEmployeeRoute({ children }) {
  const { user } = useAuth();

  if (user?.role === 'Manager') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
});